import React from 'react';

export default React.createContext({
  apiUrl: null,
  apolloState: null,
  enableServiceWorker: false,
  fileStorageApiUrl: null,
  froalaActivationKey: null,
  microsoftClientId: null,
  googleClientId: null,
  turnstileSiteKey: null,
  log: console,
  preferences: null,
  serviceUrlEdanaApiNotf: null,
  shouldHydrate: false,
});
